let view = null;

export default {
	namespace: 'template-form',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: FormView } = await import(/* webpackChunkName: "form-view" */ '../../templates/FormView');
		view = new FormView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
